module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kanto-4-943d7de15c142a21229b2118ef784b47.png";